
import Vue from 'vue';

import { faGoogle } from '@delfi.lt/fa-kit/icons/modules/classic/brands';

export default Vue.extend<unknown, unknown, unknown, unknown>({
  data() {
    return {
      faGoogle,
    };
  },
});
